import type { TableColumnGroupType, TableColumnType } from "antd/es";

export interface ColumnType<RecordType> extends Omit<TableColumnType<RecordType>, "filterMode"> {
	filterMode?: "search" | "select"; // specify when column should have search or select filter option
}
export type ColumnsType<RecordType> = Array<TableColumnGroupType<RecordType> | ColumnType<RecordType>>;

export const isColumnType = <RecordType>(
	column: TableColumnGroupType<RecordType> | ColumnType<RecordType>,
): column is ColumnType<RecordType> => Boolean((column as ColumnType<RecordType>).dataIndex);
